import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const EritreaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_14649'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_14649)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M20 0V7H0V0H20Z'
					fill='#29C53F'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M20 7V14.4667H0V7H20Z'
					fill='#579DED'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14L20 7L0 0V14Z'
					fill='#F42D56'
				/>
				<path
					d='M8.85742 6.99994C8.85742 8.42325 7.67628 9.59994 6.19076 9.59994C4.70523 9.59994 3.52409 8.42325 3.52409 6.99994C3.52409 5.57664 4.70523 4.39994 6.19076 4.39994C7.67628 4.39994 8.85742 5.57664 8.85742 6.99994Z'
					stroke='#FFC63C'
					strokeWidth='1.33333'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M5.71447 6.53331C5.97746 6.53331 6.19066 6.32438 6.19066 6.06664C6.19066 5.80891 5.97746 5.59998 5.71447 5.59998C5.45148 5.59998 5.23828 5.80891 5.23828 6.06664C5.23828 6.32438 5.45148 6.53331 5.71447 6.53331Z'
					fill='#FFC63C'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M6.6676 6.99998C6.93059 6.99998 7.14379 6.79105 7.14379 6.53332C7.14379 6.27558 6.93059 6.06665 6.6676 6.06665C6.4046 6.06665 6.19141 6.27558 6.19141 6.53332C6.19141 6.79105 6.4046 6.99998 6.6676 6.99998Z'
					fill='#FFC63C'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M6.19103 6.06663C6.45403 6.06663 6.66722 5.8577 6.66722 5.59997C6.66722 5.34223 6.45403 5.1333 6.19103 5.1333C5.92804 5.1333 5.71484 5.34223 5.71484 5.59997C5.71484 5.8577 5.92804 6.06663 6.19103 6.06663Z'
					fill='#FFC63C'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M5.71447 7.46666C5.97746 7.46666 6.19066 7.25772 6.19066 6.99999C6.19066 6.74226 5.97746 6.53333 5.71447 6.53333C5.45148 6.53333 5.23828 6.74226 5.23828 6.99999C5.23828 7.25772 5.45148 7.46666 5.71447 7.46666Z'
					fill='#FFC63C'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M6.6676 7.93333C6.93059 7.93333 7.14379 7.7244 7.14379 7.46667C7.14379 7.20893 6.93059 7 6.6676 7C6.4046 7 6.19141 7.20893 6.19141 7.46667C6.19141 7.7244 6.4046 7.93333 6.6676 7.93333Z'
					fill='#FFC63C'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M5.71447 8.40001C5.97746 8.40001 6.19066 8.19107 6.19066 7.93334C6.19066 7.67561 5.97746 7.46667 5.71447 7.46667C5.45148 7.46667 5.23828 7.67561 5.23828 7.93334C5.23828 8.19107 5.45148 8.40001 5.71447 8.40001Z'
					fill='#FFC63C'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M6.6676 8.86668C6.93059 8.86668 7.14379 8.65775 7.14379 8.40002C7.14379 8.14228 6.93059 7.93335 6.6676 7.93335C6.4046 7.93335 6.19141 8.14228 6.19141 8.40002C6.19141 8.65775 6.4046 8.86668 6.6676 8.86668Z'
					fill='#FFC63C'
				/>
			</g>
		</svg>
	);
};

export default EritreaFlagIcon;
